import { TCurrentEnvironment } from './getEnvironment'

export function getCurrentEnv(): TCurrentEnvironment {
  return (document.querySelector('meta[name="current-env"]') as HTMLMetaElement)
    .content as TCurrentEnvironment
}
